/**
 * IGT / RXConnect Meter_* pipe extract — 15 columns, 9 cumulative meters (cols 2–10).
 * Bill denomination and ticket counters are not present in this gateway feed.
 */

export const IGT_METER_PIPE_SOURCE_LABELS = {
  0: 'egm_id',
  1: 'snapshot_time',
  2: 'turnover',
  3: 'credit_win',
  4: 'cancel_credit',
  5: 'stroke',
  6: 'credit',
  7: 'cashless_in',
  8: 'cashless_out',
  9: 'cash_in',
  10: 'cash_drop',
  11: 'machine_status',
  12: 'valid_flag',
  13: 'site_name',
  14: 'site_name_dup',
}

export const IGT_METER_PIPE_MAPPINGS = {
  EgmPK: 'egm_id',
  SnapshotTime: 'snapshot_time',
  GamingDate: '',
  MeterReadTime: '',
  Turnover: 'turnover',
  CreditWin: 'credit_win',
  CancelCredit: 'cancel_credit',
  Stroke: 'stroke',
  Credit: 'credit',
  CashlessIn: 'cashless_in',
  CashlessOut: 'cashless_out',
  CashIn: 'cash_in',
  CashDrop: 'cash_drop',
  CoinOut: '',
  Bill5: '',
  Bill10: '',
  Bill20: '',
  Bill50: '',
  Bill100: '',
  TicketsIn: '',
  Venue: 'site_name',
}

/** PaySafeGo meter fields not supplied by RXConnect Meter_* (full PSG / XLSX vendors only). */
export const METER_PSG_ONLY_FIELDS = new Set([
  'GamingDate',
  'MeterReadTime',
  'CoinOut',
  'Bill5',
  'Bill10',
  'Bill20',
  'Bill50',
  'Bill100',
  'TicketsIn',
])

export const METER_FIELD_HINTS = {
  EgmPK: 'Col 0 — vendor machine id (map to house # via DimMachine)',
  SnapshotTime: 'Col 1 — 15-min snapshot timestamp',
  Turnover: 'Col 2 — cumulative turnover meter',
  CreditWin: 'Col 3 — cumulative credit win',
  CancelCredit: 'Col 4',
  Stroke: 'Col 5',
  Credit: 'Col 6 — credit meter (not credit win)',
  CashlessIn: 'Col 7',
  CashlessOut: 'Col 8',
  CashIn: 'Col 9 — use for cash-in / structuring rules',
  CashDrop: 'Col 10 — use for bill-stuffing proxy rules',
  Venue: 'Col 13 — site name',
  CoinOut: 'Not in RXConnect Meter_* — PSG / XLSX only',
  Bill5: 'Not in RXConnect Meter_* — required for denomination rules',
  Bill10: 'Not in RXConnect Meter_* — PSG bill-stuffing rules use Bill10',
  Bill20: 'Not in RXConnect Meter_*',
  Bill50: 'Not in RXConnect Meter_* — rules like Bill50 + low turnover need this',
  Bill100: 'Not in RXConnect Meter_* — rules like Bill100 + low turnover need this',
  TicketsIn: 'Not in RXConnect Meter_*',
  GamingDate: 'Not in RXConnect Meter_*',
  MeterReadTime: 'Not in RXConnect Meter_*',
}

export function referenceIgtMeterTemplateContent() {
  return {
    sourceFormat: 'pipe-delimited',
    hasHeader: false,
    vendorNotes:
      'RXConnect Meter_* — 9 cumulative meters (cols 2–10), then status flags. Bill/Ticket/CoinOut are PSG-only.',
    sourceLabels: { ...IGT_METER_PIPE_SOURCE_LABELS },
    mappings: { ...IGT_METER_PIPE_MAPPINGS },
  }
}

export const IGT_METER_TEMPLATE_JSON = referenceIgtMeterTemplateContent()
